<template>
    <div class="form-group" :class="{'mb-2': marginBottom }">
        <label v-if="labelPosition != 'hidden'" :class="{'input-label': labelPosition == 'center', 'input-label-left': labelPosition == 'left' }">AGENTE IA</label>
        <label class="ia-toggle-card" :class="{ active: model, 'pointer-events-none': readOnly, 'mt-2': labelPosition == 'hidden' }" :for="inputId">
            <div class="ia-toggle-text">
                <span class="ia-toggle-title">
                    <i class="ri-robot-2-line me-1"></i> Agente IA <template v-if="model">ativado</template><template v-else>desativado</template>
                </span>
                <span class="ia-toggle-desc">
                    <template v-if="model">Os eventos deste contato <u class="ia-toggle-desc-bold">serão</u> repassados ao Agente de IA.</template>
                    <template v-else>Os eventos deste contato <u class="ia-toggle-desc-bold">não serão</u> repassados ao Agente de IA.</template>
                </span>
            </div>
            <div v-if="!nonEditable" class="form-check form-switch m-0 pointer-events-none">
                <input
                    :id="inputId"
                    class="form-check-input custom-switch-ia"
                    type="checkbox"
                    role="switch"
                    v-model="model"
                >
            </div>
        </label>
    </div>
</template>
<script setup lang="ts">
import { PropType, getCurrentInstance } from 'vue';

const props = defineProps({
    readOnly: { type: Boolean, default: false },
    nonEditable: { type: Boolean, default: false },
    labelPosition: { type: String as PropType<'left'|'center'|'hidden'>, default: 'center' },
    marginBottom: { type: Boolean, default: true },
})
const model = defineModel<boolean>()

// id único por instância: evita colisão quando o modal (ContactFormModal) e a
// sidebar (ChatProfileSidebar) renderizam o toggle ao mesmo tempo. Com id fixo,
// o <label for=...> do modal acionava o checkbox da sidebar (primeiro id igual no DOM).
const inputId = `contact-agente-ia-${getCurrentInstance()?.uid}`
</script>
<style scoped>
.input-label {
    font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase;
    letter-spacing: 0.6px; margin-bottom: 8px; display: block;
}
.input-label-left {
    font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase;
    letter-spacing: 0.6px; margin-bottom: 8px; display: flex;
}

.input-wrapper { position: relative; }
.input-icon {
    position: absolute; left: 16px; top: 50%; transform: translateY(-50%);
    color: #64748b; font-size: 18px;
}

/* Switch Customizado */
.custom-switch {
    width: 3em !important; height: 1.6em !important; cursor: pointer;
    background-color: #cbd5e1; border: none;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e") !important;
    transition: background-position .15s ease-in-out, background-color 0.2s;
}
.custom-switch:checked {
    background-color: #db2777; /* Rosa Premium (ou use #25D366 para WhatsApp) */
    background-color: #db2777;
}
.form-check-input:focus { box-shadow: none; }

/* === AGENTE IA TOGGLE === */
.ia-toggle-card {
    width: 100%;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 14px 16px;
    display: flex; align-items: center; justify-content: space-between; gap: 12px;
    cursor: pointer;
    transition: all 0.2s;
    margin: 0;
}
.ia-toggle-card.active {
    background-color: #f0fdf4;
    border-color: #25D366;
}
.ia-toggle-text { display: flex; flex-direction: column; text-align: left; }
.ia-toggle-title { font-size: 14px; font-weight: 600; color: #334155; }
.ia-toggle-desc { font-size: 11px; color: #64748b; margin-top: 2px; line-height: 1.4; }
.ia-toggle-desc-bold { font-size: 11px; font-weight: 700; color: #718096; margin-top: 2px; line-height: 1.4; }

.pointer-events-none { pointer-events: none; }

.form-check.pointer-events-none { pointer-events: none; }

.custom-switch-ia {
    width: 2.8em !important; height: 1.5em !important; cursor: pointer;
    background-color: #cbd5e1; border-color: #cbd5e1;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e") !important;
}
.custom-switch-ia:checked { background-color: #25D366; border-color: #25D366; }
.custom-switch-ia:focus { box-shadow: none; border-color: #25D366; }

[data-bs-theme="dark"] .ia-toggle-card { background-color: #334155; border-color: #475569; }
[data-bs-theme="dark"] .ia-toggle-card.active { background-color: rgba(37, 211, 102, 0.08); border-color: #25D366; }
[data-bs-theme="dark"] .ia-toggle-title { color: #e2e8f0; }
[data-bs-theme="dark"] .ia-toggle-desc { color: #94a3b8; }
</style>